export const moneyMask = (value) => {
  value = value.replace('.', '').replace(',', '').replace(/\D/g, '')
  const options = { minimumFractionDigits: 2 }
  const result = new Intl.NumberFormat('pt-BR', options).format(
    parseFloat(value) / 100
  )
  console.log(result)
  return 'R$ ' + result
}

export const dolarMask = (value) => {
  let dolarFormater = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

  return dolarFormater.format(value)

}